import { LOCAL_STORAGE_KEYS } from '../constants';

export function getWebsiteUserFromLocalStorage() {
  try {
    return JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_KEYS.WEBSITE_USER) || '{}');
  } catch (err) {
    return null;
  }
}
